export const SKELETON_ICON_SIZE = 24;
export const SKELETON_LABEL_WIDTH = 48;
export const SKELETON_LABEL_HEIGHT = 8;
